var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout-vr"},[(_vm.$slots.header)?_c('section',{staticClass:"header"},[_vm._t("header")],2):_vm._e(),(_vm.$slots.default)?_c('section',{staticClass:"main",class:[_vm.ovflowFlowMain]},[_vm._t("default")],2):_vm._e(),(_vm.$slots.footer)?_c('section',{staticClass:"footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }